import { useAuthQuery } from '#lib/hooks/use-auth-query.js';
import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { getAuthHeader } from '#lib/hooks/use-auth.jsx';
import useMutation from '#lib/hooks/use-mutation.js';
import { toast } from 'react-hot-toast';

async function fetchItineraryOptions(_, authHeaders) {
    const response = await fetch(`${API_URL}/p/itineraryoption`, {
        method: 'GET',
        headers: { ...jsonHeaders, ...authHeaders }
    });
    return await response.json();
}

async function putItineraryOptions(body) {
    const authHeaders = await getAuthHeader();
    return await fetchAndParse(`${API_URL}/p/itineraryoption`, {
        method: 'PUT',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(body)
    });
}

async function createItineraryOption(body) {
    const authHeaders = await getAuthHeader();
    return await fetchAndParse(`${API_URL}/p/itineraryoption`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(body)
    });
}

async function destroyItineraryOption(body) {
    const authHeaders = await getAuthHeader();
    return await fetchAndParse(`${API_URL}/p/itineraryoption`, {
        method: 'DELETE',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(body)
    });
}

export function useProfilesQueries() {
    const { data, refetch, isLoading, ...queryProps } = useAuthQuery({
        queryKey: ['itineraryOptions'],
        queryFn: fetchItineraryOptions,
        staleTime: Infinity,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        retry: false,
        cacheTime: 0
    });

    const updateItineraryOptions = useMutation({
        mutationKey: ['updateItineraryOption'],
        mutationFn: async (model) => {
            await putItineraryOptions(model);
        },
        onSuccess: () => {
            toast.success(_t.global.success());
            refetch();
        },
        onError: (err) => toast.error(err.message),
        enabled: false
    });

    const createItineraryOptions = useMutation({
        mutationKey: ['createItineraryOption'],
        mutationFn: async (model) => {
            await createItineraryOption(model);
        },
        onSuccess: () => {
            toast.success(_t.global.success());
            refetch();
        },
        onError: () => toast.error(''),
        enabled: false
    });

    const destroyItineraryOptions = useMutation({
        mutationKey: ['deleteItineraryOption'],
        mutationFn: async (model) => {
            await destroyItineraryOption(model);
        },
        onSuccess: () => {
            toast.success(_t.global.success());
        },
        onError: () => toast.error(''),
        updateSuccess: (prev) => {},
        enabled: false
    });

    return {
        itineraryOptions: data?.data,
        refetch,
        isLoading,
        updateItineraryOptions,
        createItineraryOptions,
        destroyItineraryOptions,
        ...queryProps
    };
}
